module.exports = __webpack_public_path__ + "static/virginia.7914a24d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/virginia.png
// module id = ./assets/virginia.png
// module chunks = 269238729700051